



















































































































import commonApi from "@/api/commonApi";
import productApi from "@/api/productApi";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import { CartItemList } from "@/model/cart";
import Product, { SaleBoom } from "@/model/product";
import RemoveItemInactive from "@/mixin/removeItemInactive";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";

const cartStore = namespace("Cart");
@Component({
  name: "CustomerCart",
  components: {
    QErrors,
  },
})
export default class CustomerCart extends Mixins(RemoveItemInactive) {
  @cartStore.Getter
  cartItems!: any[];

  @cartStore.Action
  cartRemove!: (index) => void;
  @cartStore.Action
  replaceCart!: (item) => void;
  @cartStore.Action
  addCart!: (item) => void;
  @cartStore.Action
  updateItem!: (item) => void;

  public items: CartItemList = null;
  // do not remove this var it's using on Mixin
  isCartPage = true;

  public deliveryConfig = {
    order_deadline_hour: 10,
    order_deadline_minute: 10,
    calendar_period: 90,
    free_shipping: 3000,
  };

  public errors: any = {};

  async mounted() {
    this.items = new CartItemList();
    this.deliverySetting();
    this.loadData();
  }

  get showFreeShip(): boolean {
    return this.items.total < this.deliveryConfig.free_shipping;
  }

  public async deliverySetting() {
    const result = await commonApi.setting({});
    this.deliveryConfig = result;
  }

  async loadData() {
    const loader = Vue.$loading.show({});
    let setItemCode = this.cartItems
      .filter((item) => item.set_item_code)
      .map((item) => item.set_item_code);
    let itemCode = this.cartItems
      .filter((item) => !item.set_item_code)
      .map((item) => item.item_code);

    const request: any = [];
    if (setItemCode.length > 0) {
      request.push(
        productApi.getSaleBoms({
          set_item_code: setItemCode,
        })
      );
    } else {
      request.push([]);
    }

    if (itemCode.length > 0) {
      request.push(
        productApi.getAll({
          item_codes: itemCode,
          is_publish: true,
          per_page: 100000,
          include_sales_judge_kbn: true,
        })
      );
    } else {
      request.push([]);
    }
    try {
      const result = await Promise.all(request);
      const itemsNeedRemove = [];
      this.cartItems.map((item, index) => {
        console.log(item);
        if (item.set_item_code && result[0]) {
          let itemSale = (result[0] as SaleBoom[]).find(
            (itemSale) => itemSale.set_item_code === item.set_item_code
          );
          if (itemSale) {
            itemSale.cart_quanlity = item.cart_quanlity;
            itemSale.uuid = item.uuid;
            this.items.push(new SaleBoom({ ...itemSale }));
          } else {
            itemsNeedRemove.push(index);
          }
        } else if (item.set_item_code == null && result[1]) {
          const products: Product[] = result[1]["list"];
          let itemProduct = products.find(
            (itemSale) => itemSale.item_code === item.item_code
          );
          if (itemProduct) {
            itemProduct.cart_quanlity = item.cart_quanlity;
            itemProduct.uuid = item.uuid;
            this.items.push(new Product({ ...itemProduct }));
          } else {
            itemsNeedRemove.push(index);
          }
        }
      });
      if (itemsNeedRemove.length > 0) {
        itemsNeedRemove.map((itemKey) => {
          this.cartRemove(itemKey);
          return itemKey;
        });
      }
    } catch (error) {
      console.error(error);
      qNotify.error({
        text: this.$t("error"),
      });
    } finally {
      loader.hide();
    }
  }

  public removeCart(index) {
    const product = this.items.list[index];
    this.$modal.showDelete({
      text: this.$t("cart_page.messsage.delete_message", {
        item_name_1: product.itemName,
        item_name_2: product.itemName2,
        item_code: product.itemCode,
      }),
      confirmClass: "mb__add-color-red",
      title: this.$t("cart_page.messsage.title_popup_delete"),
      cancelText: this.$t("common.message.cancel_delete_button"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.items.list.splice(index, 1);
        this.cartRemove(index);
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public order() {
    // set quantity
    if (!this.checkItemAvaiable()) {
      return;
    }

    this.errors = {};
    if (!this.canProcess()) {
      return;
    }

    this.replaceCart([]);
    this.items.list.map(({ item }) => {
      this.addCart([item]);
    });
    this.$router.push({ name: "customer.order" });
  }
}
